// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";
import { useSnackbarContext } from "src/contexts/alerts/SnackbarContext";

// API
import { deleteUnassignedEMR } from "../api";

export const useDeleteUnassignedEMR = (clinicId: string | undefined) => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();
  const { t } = useTranslation();
  const { setSnackbarInfo } = useSnackbarContext();

  return useMutation({
    mutationFn: async (emrJobId: string) => {
      if (!clinicId) throw new Error();

      try {
        const token = await getToken();
        return deleteUnassignedEMR(token, clinicId, emrJobId);
      } catch (error) {
        throw error;
      }
    },
    // Invalidate cache
    onSuccess: (_) => {
      queryClient.invalidateQueries({
        queryKey: ["unassigned-emr", clinicId],
      });
      setSnackbarInfo({
        variant: "success",
        message: t("Exam deleted successfully!"),
      });
    },
    onError: () => {
      setSnackbarInfo({
        variant: "error",
        message: t("Exam could not be deleted!"),
      });
    },
  });
};
